


























import { Component, Vue } from "@/shared/vuepack";
import HsabExpenseForm from "@/employee/components/landing-pages/hsabank/expense/HsabExpenseForm.vue";
import { HsabExpenseFormMode, HsabExpenseFormStep, HsabExpenseResponse } from "@/shared/types";
import { useThemeStore } from "@/shared/store/theme";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useHsabExpenseFormStore } from "@/employee/store/hsabExpenseForm";
import { useBankAccountStore } from "@/employee/store/bankAccount";

@Component({
  components: { GenericLoadingSpinner, HsabExpenseForm }
})
export default class HsabExpenseEditModal extends Vue {
  themeStore = useThemeStore();
  hsabExpenseFormStore = useHsabExpenseFormStore();
  bankAccountStore = useBankAccountStore();

  get showModal () {
    return this.hsabExpenseFormStore.showCreateOrEditModal;
  }


  get expense (): HsabExpenseResponse {
    return this.hsabExpenseFormStore.expense;
  }

  handleOnEditClose () {
    if (!this.hsabExpenseFormStore.recentlySubmitted) {
      this.hsabExpenseFormStore.formStepToDisplay = HsabExpenseFormStep.details;
      this.$nextTick(() => {
        this.hsabExpenseFormStore.updateModalMode(HsabExpenseFormMode.none);
      });
    }

    if (this.bankAccountStore.isAchIFrameLoaded) {
      this.bankAccountStore.destroyAchIFrame(window);
    }
  }
}
